import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditAssignCourseLayer from "../components/EditAssignCourseLayer";


const EditAssignCoursePage = () => {
  return (
    <>



        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Assign Course  </h5><Breadcrumb title="Edit Assign Course" /></div>


        {/* UsersListLayer */}
        <EditAssignCourseLayer />



    </>
  );
};

export default EditAssignCoursePage; 